import { render, staticRenderFns } from "./menuCenter.vue?vue&type=template&id=15e598b2&scoped=true"
import script from "./menuCenter.vue?vue&type=script&lang=js"
export * from "./menuCenter.vue?vue&type=script&lang=js"
import style0 from "./menuCenter.vue?vue&type=style&index=0&id=15e598b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e598b2",
  null
  
)

export default component.exports